module.exports = __webpack_public_path__ + "static/media/sets.da217e93.jpg";